export const positionsSrc = {
 "1": {
  "x": 468.6612548828125,
  "y": 11.23333740234375
 },
 "5": {
  "x": 920.6015014648438,
  "y": 219.82083129882812
 },
 "7": {
  "x": 628.14404296875,
  "y": 214.0267333984375
 },
 "10": {
  "x": 1579.996826171875,
  "y": 544.4939575195312
 },
 "12": {
  "x": 1348.820556640625,
  "y": 864.9209594726562
 },
 "14": {
  "x": 1567.1842041015625,
  "y": 275.9447021484375
 },
 "16": {
  "x": 20.12548828125,
  "y": 236.43206787109375
 },
 "19": {
  "x": 381.515625,
  "y": 211.36984252929688
 },
 "21": {
  "x": 20.5,
  "y": 131.46359252929688
 },
 "24": {
  "x": 39.74562072753906,
  "y": 35.603271484375
 },
 "27": {
  "x": 25.457305908203125,
  "y": 17.975433349609375
 },
 "30": {
  "x": 1644.479995727539,
  "y": 28.4642333984375
 },
 "32": {
  "x": 1190.3956298828125,
  "y": 351.61767578125
 },
 "34": {
  "x": 1187.41748046875,
  "y": 223.9642333984375
 },
 "36": {
  "x": 1649,
  "y": 6.104248046875
 },
 "44": {
  "x": 763.5885620117188,
  "y": 10.836212158203125
 },
 "47": {
  "x": 1030.389892578125,
  "y": 674.4871215820312
 },
 "49": {
  "x": 396.37982177734375,
  "y": 531.3634948730469
 },
 "51": {
  "x": 986.7714233398438,
  "y": 525.270263671875
 },
 "53": {
  "x": 50,
  "y": 650
 },
 "55": {
  "x": 350,
  "y": 650
 },
 "57": {
  "x": 1661.03271484375,
  "y": 175.94674682617188
 },
 "58": {
  "x": 723.47998046875,
  "y": 573.5564575195312
 },
 "60": {
  "x": 50,
  "y": 770
 },
 "67": {
  "x": 350,
  "y": 770
 },
 "86": {
  "x": 650,
  "y": 770
 },
 "88": {
  "x": 1031.7714233398438,
  "y": 839.840087890625
 },
 "93": {
  "x": 50,
  "y": 890
 },
 "95": {
  "x": 350,
  "y": 890
 },
 "97": {
  "x": 650,
  "y": 890
 },
 "107": {
  "x": 1265.9178466796875,
  "y": 1016.133056640625
 },
 "112": {
  "x": 1633.479995727539,
  "y": 436.462646484375
 },
 "115": {
  "x": 350,
  "y": 1010
 },
 "117": {
  "x": 383.47998046875,
  "y": 334.4642333984375
 },
 "119": {
  "x": 950,
  "y": 1010
 },
 "141": {
  "x": 634.4432983398438,
  "y": 332.5046081542969
 },
 "148": {
  "x": 350,
  "y": 1130
 },
 "150": {
  "x": 648.5292358398438,
  "y": 1063.011962890625
 },
 "155": {
  "x": 950,
  "y": 1130
 },
 "160": {
  "x": 54.973236083984375,
  "y": 1210.945068359375
 },
 "164": {
  "x": 350,
  "y": 1250
 },
 "166": {
  "x": 650,
  "y": 1250
 },
 "168": {
  "x": 950,
  "y": 1250
 },
 "170": {
  "x": 50,
  "y": 1370
 },
 "171": {
  "x": 350,
  "y": 1370
 },
 "176": {
  "x": 650,
  "y": 1370
 },
 "178": {
  "x": 950,
  "y": 1370
 },
 "181": {
  "x": 50,
  "y": 1490
 },
 "187": {
  "x": 350,
  "y": 1490
 },
 "192": {
  "x": 650,
  "y": 1490
 },
 "197": {
  "x": 950,
  "y": 1490
 },
 "207": {
  "x": 50,
  "y": 1610
 },
 "209": {
  "x": 350,
  "y": 1610
 },
 "211": {
  "x": 667.1651000976562,
  "y": 1647.4727783203125
 },
 "215": {
  "x": 1285.0787353515625,
  "y": 1585.1395263671875
 },
 "216": {
  "x": 50,
  "y": 1730
 },
 "222": {
  "x": 350,
  "y": 1730
 },
 "228": {
  "x": 655.9656372070312,
  "y": 1794.7032470703125
 },
 "231": {
  "x": 990.3615112304688,
  "y": 1718.4635009765625
 },
 "233": {
  "x": 50,
  "y": 1850
 },
 "235": {
  "x": 350,
  "y": 1850
 },
 "237": {
  "x": 698,
  "y": 1973
 },
 "240": {
  "x": 19.670310974121094,
  "y": 360.041748046875
 },
 "242": {
  "x": 50,
  "y": 1970
 },
 "244": {
  "x": 350,
  "y": 1970
 },
 "-999650516": {
  "x": 1071.23193359375,
  "y": 16.041717529296875
 }
}